<template>
  <div class="involvement">
    <ul class="involvement__header">
      <li class="involvement__title">
        {{chartTitle}}
      </li>
      <li class="involvement__tools">
        <el-button type="text" class="involvement__tools-button" :disabled="saveChart" @click="onSave">
          <i class="material-icons color_grey">save</i>
        </el-button>
        <el-button type="text" class="involvement__tools-button" v-if="!isEdit" @click="editChart">
          <i class="material-icons color_grey">edit</i>
        </el-button>
      </li>
    </ul>

    <el-card shadow="hover" class="involvement__card" v-loading="pending">
      <involvement-header
        :chart-name="name"
      />

      <involvement-body
        :data="data"
        :chart-name="name"
        :save-chart="saveChart"
        :title="chartTitle"
        @onSavedChart="handleSaved"
        @onSaveChart="handleSave"
      />
    </el-card>
  </div>
</template>

<script>
  /*
    deprecated component
    app use actually component is InvolvementPlotly
  */

  // mixins
  import { audit } from "../../../../../../../mixins/audit";

  // components
  import InvolvementHeader from "./header/InvolvementHeader";
  import InvolvementBody from "./body/InvolvementBody";

  export default {
    name: "Involvement",
    data() {
      return {
        name: "Involvement",
        saveChart: false,
        chartTitle: this.$t('feed.audit.involvement.title'),
      };
    },
    components: {
      InvolvementHeader,
      InvolvementBody
    },
    mixins: [
      audit
    ],
  }
</script>

<style>
  .involvement__header {
    display: flex;
    justify-content: space-between;
    align-items: start;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .involvement__title {
    margin-bottom: 20px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #5E6D82;
  }

  .involvement__tools .material-icons {
    font-size: 16px;
  }

  .involvement__tools {
    margin-top: 4px;
    margin-right: 15px;
  }

  .involvement__tools-button {
    padding: 0;
    color: #5e6d82;
  }

  .involvement__tools-button:hover {
    color: #B3BCCC;
    font-size: 12px;
  }

  .involvement__card {
    margin-bottom: 20px;
  }
</style>
